export default "__VITE_ASSET__b7fc48e7__"